import { useEffect } from 'react';
import { useDrumAdapter } from '../../contexts/DrumContext';
export function useDrumHits(clock, onHit, messagesRef, onChoke) {
    const drumAdapter = useDrumAdapter(clock);
    useEffect(() => {
        if (drumAdapter != null) {
            const handleMessage = (message) => {
                messagesRef?.current?.push(message);
            };
            const handleUnknownNote = (event) => {
                console.warn('Unknown note', event);
            };
            const handleHit = onHit ?? (() => {
            });
            drumAdapter.addEventListener('hit', handleHit);
            if (onChoke != null) {
                drumAdapter.addEventListener('choke', onChoke);
            }
            drumAdapter.addEventListener('unknownnote', handleUnknownNote);
            drumAdapter.addEventListener('message', handleMessage);
            return () => {
                drumAdapter.removeEventListener('hit', handleHit);
                if (onChoke != null) {
                    drumAdapter.removeEventListener('choke', onChoke);
                }
                drumAdapter.removeEventListener('unknownnote', handleUnknownNote);
                drumAdapter.removeEventListener('message', handleMessage);
            };
        }
    }, [clock, drumAdapter, onChoke, onHit, messagesRef]);
}
//# sourceMappingURL=useDrumHits.js.map